import { DEPLOYMENT_DOMAIN, DeploymentEnvironment } from '@env';

export type DatadogEnv = 'production' | 'non-production' | 'preview';

// Maps the webapp's DeploymentEnvironment to the `env` tag Datadog telemetry
// (RUM, browser logs, server OTel) should emit. Returns null for environments
// we don't send telemetry from (Development).
export function getDatadogEnv(
  domain: DeploymentEnvironment = DEPLOYMENT_DOMAIN,
): DatadogEnv | null {
  switch (domain) {
    case DeploymentEnvironment.Production:
      return 'production';
    case DeploymentEnvironment.NonProduction:
      return 'non-production';
    case DeploymentEnvironment.Preview:
      return 'preview';
    default:
      return null;
  }
}
